import React from "react";

import { ProductItem } from "@is/types";

import ProductRowItem from "../ProductRowItem";
import css from "./ProductRow.module.css";

type Props = {
  row: ProductItem[];
  sectionId: string;
  contentItemId: string;
};

const ProductRow = ({ row, sectionId, contentItemId }: Props) => {
  return (
    <div className={css.container}>
      {row.map((item, index) => (
        <ProductRowItem
          key={`${item.id}_${index}`}
          item={item}
          sectionId={sectionId}
          contentItemId={contentItemId}
        />
      ))}
    </div>
  );
};

export default ProductRow;
